import initState from '@shared/init-state-v0.1.0'
import type { JsNodeDef } from '@shared/node-v1.0.0'
import type { BaseJsProps } from '@shared/node-v1.0.0'
import { getPortDef } from '@shared/port-v1.0.0'

export type Props = BaseJsProps & { path: string; params?: Record<string, string> }

export default {
	hashTag: '#experimental',
	module: { dynamic: import('../component') },
	inNode: {
		inputs: [
			getPortDef({
				name: 'path',
				displayName: 'Page',
				group: 'Params',
				type: [],
				transform: (p, portDef) => {
					const navScheme = R.navigation?.scheme
					portDef.type = navScheme?.map((i) => ({ value: i.path, label: i.page })) || []
				},
			}),
			getPortDef({ name: 'params', displayName: 'Params', group: 'Params', type: 'object' }),
			getPortDef({ name: 'navigate', displayName: 'Navigate', group: 'Signals', type: 'signal' }),
		],
		outputs: [getPortDef({ name: 'navigated', displayName: 'Navigated', group: 'Signals', type: 'signal' })],
	},
	afterNode: {
		transformPorts: async () => {
			// transform в инпуте path без этого не сработает
			await initState('navigation')
		},
	},
	disableCustomProps: true,
} satisfies JsNodeDef
